{
  "title": "Promotions",
  "subtitle": "Discounts set once that apply by themselves, on the dates and sales you choose.",
  "new": "New promotion",
  "empty": {
    "title": "No promotion yet",
    "text": "A promotion lowers prices by itself: at the till, in back-office orders and in the online store."
  },
  "tabs": {
    "all": "All",
    "active": "Active",
    "scheduled": "Scheduled",
    "paused": "Paused",
    "ended": "Ended"
  },
  "status": {
    "active": "Active",
    "scheduled": "Scheduled",
    "paused": "Paused",
    "ended": "Ended"
  },
  "types": {
    "percent": "Percentage off",
    "amount": "Amount off",
    "fixedPrice": "Fixed price",
    "buyGet": "Buy X get Y",
    "quantity": "Quantity price",
    "pack": "Pack",
    "orderPercent": "Percentage off the sale",
    "orderAmount": "Amount off the sale"
  },
  "targets": {
    "products": "Products",
    "categories": "Categories",
    "brands": "Brands",
    "all": "Everything"
  },
  "saleTypes": {
    "retail": "Retail",
    "wholesale": "Wholesale",
    "both": "Retail and wholesale"
  },
  "channels": {
    "pos": "Till",
    "online": "Online store",
    "backOffice": "Back office"
  },
  "list": {
    "search": "Name or code of the promotion",
    "type": "Type",
    "allTypes": "All types",
    "saleType": "Sale type",
    "allSaleTypes": "All sale types",
    "noMatch": "No promotion matches these filters.",
    "uses_one": "{{value}} use",
    "uses_other": "{{value}} uses",
    "usesOf": "{{uses}} / {{max}} uses",
    "showing_one": "{{first}}–{{last}} of {{total}} promotion",
    "showing_other": "{{first}}–{{last}} of {{total}} promotions"
  },
  "columns": {
    "promotion": "Promotion",
    "offer": "Offer",
    "saleType": "Sale type",
    "dates": "Dates",
    "status": "Status"
  },
  "summary": {
    "on": "on",
    "everything": "everything",
    "andMore_one": "{{names}} and {{count}} more",
    "andMore_other": "{{names}} and {{count}} more",
    "except_one": "except {{count}} product",
    "except_other": "except {{count}} products",
    "saleTypes": {
      "retail": "retail",
      "wholesale": "wholesale",
      "both": "retail and wholesale"
    },
    "allSites": "all sites",
    "between": "{{from}} to {{to}}",
    "from": "from {{from}}",
    "gives": "gives {{names}}",
    "minQuantity": "from {{quantity}} pieces",
    "minAmount": "from {{amount}}",
    "code": "with the code {{code}}",
    "tags": "for customers tagged {{tags}}",
    "maxUses_one": "{{count}} use in all",
    "maxUses_other": "{{count}} uses in all",
    "maxPerCustomer_one": "{{count}} use per customer",
    "maxPerCustomer_other": "{{count}} uses per customer",
    "pack": "{{offer}}: {{names}}"
  },
  "actions": {
    "more": "Actions for {{name}}",
    "edit": "Edit",
    "duplicate": "Duplicate",
    "pause": "Pause",
    "resume": "Resume",
    "end": "End now",
    "delete": "Delete"
  },
  "done": {
    "pause": "{{name}} is paused.",
    "resume": "{{name}} runs again.",
    "end": "{{name}} has ended.",
    "delete": "{{name}} was deleted."
  },
  "confirm": {
    "end": {
      "title": "End {{name}} now?",
      "text": "Prices go back to normal at once. Past sales keep their promotion.",
      "action": "End now"
    },
    "delete": {
      "title": "Delete {{name}}?",
      "text": "No sale used this promotion, so it can go for good.",
      "action": "Delete"
    }
  },
  "form": {
    "newTitle": "New promotion",
    "editTitle": "Edit the promotion",
    "saved": "Promotion saved.",
    "name": "Name",
    "namePlaceholder": "Eid sale",
    "what": "What does it give?",
    "value": {
      "percent": "Percentage off",
      "amount": "Amount off each piece",
      "fixedPrice": "Price of each piece",
      "buyGet": "Discount",
      "quantity": "Percentage off",
      "pack": "Price of the pack",
      "orderPercent": "Percentage off the sale",
      "orderAmount": "Amount off the sale"
    },
    "orderHint": "Taken off the whole sale and shared over its lines. Lines with a promotion of their own stay out, but they count for the minimum.",
    "onWhat": "On what?",
    "findProduct": "Find a product: name, SKU or barcode",
    "addCategory": "Add a category",
    "addBrand": "Add a brand",
    "targetRequired": "Choose at least one.",
    "exceptions": "Except these products",
    "findException": "Find a product to leave out",
    "removeItem": "Remove {{name}}",
    "forWhich": "For which sales?",
    "saleType": "Sale type",
    "wholesaleHint": "Wholesale prices already have a small margin: check that this one still pays.",
    "channels": "Channels",
    "channelRequired": "Choose at least one channel.",
    "sites": "Sites",
    "sitesHint": "None ticked: all sites. Sites count for the till and the back office, not for the online store.",
    "forWhom": "For whom?",
    "code": "Promotion code",
    "codeHint": "Empty: it applies by itself. With a code, only on a sale that gives it.",
    "customerTags": "Customer tags",
    "customerTagsHint": "Empty: everyone. Otherwise, customers with one of these tags.",
    "maxUses": "Uses in all",
    "maxUsesHint": "Sales it can serve. Empty: no limit.",
    "maxPerCustomer": "Uses per customer",
    "maxPerCustomerHint": "Needs a customer on the sale. Empty: no limit.",
    "when": "When?",
    "startsOn": "First day",
    "endsOn": "Last day",
    "endsHint": "Empty: until you end it.",
    "buy": "Buy",
    "get": "Get",
    "getAt": "Discount",
    "maxSets": "At most, per sale",
    "buyGetHint": "100 % is free. The cheapest piece is the one given, and its value is shared over the lines: a return gives back what was paid.",
    "fromQuantity": "From this quantity",
    "tierPercent": "Percentage off",
    "removeTier": "Remove this level",
    "addTier": "Add a level",
    "tiersInvalid": "Quantities must go up from one level to the next.",
    "packItems": "What does the pack hold?",
    "packHint": "A product takes any of its variants; scan a barcode to name one variant. The pack applies by itself once all its pieces are on the sale, and its saving is shared over their lines.",
    "packMaxHint": "Empty: each complete set is a pack.",
    "packQuantity": "How many of {{name}}",
    "packRetail": "A pack is for retail sales only.",
    "whatTheyBuy": "What do they buy?",
    "whatItGives": "What do they get?",
    "sameProducts": "The same products",
    "minQuantity": "From this quantity",
    "minAmount": "From this amount",
    "minimumHint": "Of what it covers on the sale. Empty: from the first piece.",
    "days": "Days",
    "daysHint": "None ticked: every day.",
    "fromTime": "From",
    "toTime": "To",
    "belowCost": {
      "title_one": "{{value}} product would sell below cost",
      "title_other": "{{value}} products would sell below cost",
      "text": "{{names}}. You can still save: clearing old stock is a real need.",
      "action": "Save anyway"
    }
  },
  "product": {
    "hint": "What lowers this product now or soon, the best one applying."
  },
  "offer": {
    "free": "Buy {{buy}}, get {{get}} free",
    "reduced": "Buy {{buy}}, get {{get}} at −{{percent}} %",
    "order": "{{value}} off the sale",
    "pack": "Pack at {{price}}"
  },
  "days": {
    "0": "Sun",
    "1": "Mon",
    "2": "Tue",
    "3": "Wed",
    "4": "Thu",
    "5": "Fri",
    "6": "Sat"
  }
}
